var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"o-table"},[_c('thead',[_c('tr',[_vm._t("headers")],2)]),_c('tbody',{ref:"tbody"},[_vm._t("body")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }